import { reatomAsync, withDataAtom } from "@reatom/async";
import { PageableRequestWithUserIdDto } from "definitions/poizon-sso";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getAccessRightsByUserId = reatomAsync(
  async (ctx, data: PageableRequestWithUserIdDto) => {
    return API.accessRightApi
      .accessRightControllerGetAccessRightsByUserId(data)
      .then((response) => response.data);
  },
  "getAccessRightsByUserIdRequest",
).pipe(withDataAtom({ data: [], totalItems: 0 }), withIsLoadingAtom());
